// extracted by mini-css-extract-plugin
module.exports = {"subtabMenu":"SubtabMenu_subtabMenu__2IagJ","hover":"SubtabMenu_hover__5N_Pb"};